import {typeReservationConstants} from  './typeReservation.constants'
const {
    FETCHING_TYPE_RESERVATION_SUCCESS
} = typeReservationConstants

const defaultState = {
    typeReservation:undefined
}


const TypeReservationReducer = (state = defaultState , action) => {
    switch (action.type) {
        case FETCHING_TYPE_RESERVATION_SUCCESS:
            return{
                ...state,
                typeReservation:action.typeReservation,
        };
        default:
        return state;
    }
};

export  default  TypeReservationReducer;